export default class ResponsiveMenu {
    constructor() {
        this.menuButton = document.querySelector('.menuButton');
        this.pageWrapper = document.querySelector('.pageWrapper');
        this.open = false;
        this.bindEvents();
    }

    bindEvents() {
        this.menuButton.addEventListener('click', () => this.menuHandler());
        this.pageWrapper.addEventListener('click', (event) => this.clickOutSideMenu(event));
    }

    clickOutSideMenu(event) {
        // NOTE: Lägg till funktionalitet.
    }

    menuHandler() {
        if (this.open) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.open = true;
        document.body.classList.add('responsiveMenu--open');
    }

    closeMenu() {
        this.open = false;
        document.body.classList.remove('responsiveMenu--open');
    }
}



// WEBPACK FOOTER //
// ./src/components/responsiveMenu/responsiveMenu.js